import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import {
  CHECK_AVAILABILITY,
  CONFIRM_OFFER,
  ERROR_CANCELLATION,
  ERROR_CONFIRMATION,
  SELECT_OFFER,
} from './constants'

import { getBoardSelected, getDatesAndPaxes, getStep } from 'src/effects/ModifyDates/selectors'
import { typeBookingInformation } from 'client/types/voucher'
import { typeRef } from 'client/types'

import CheckAvailability from 'src/effects/ModifyDates/CheckAvailability'
import ConfirmationError from 'src/effects/ModifyDates/ConfirmationError'
import ConfirmExit from 'src/effects/ModifyDates/ConfirmExit'
import ConfirmOffer from 'src/effects/ModifyDates/ConfirmOffer'
import SelectOffer from 'src/effects/ModifyDates/SelectOffer'

const stepsMap = {
  [CHECK_AVAILABILITY]: 0,
  [SELECT_OFFER]: 1,
  [CONFIRM_OFFER]: 2,
  [ERROR_CANCELLATION]: 3,
  [ERROR_CONFIRMATION]: 4,
}

const ModifyDates = ({
  bookingInformation,
  modifyDatesSectionRef,
  propertyId = '',
  sellingRate,
  rooms = 1,
}) => {
  const boardSelected = useSelector(getBoardSelected)
  const datesAndPaxes = useSelector(getDatesAndPaxes)
  const step = useSelector(getStep)
  const [currentIndex, setCurrentIndex] = useState(0)

  const bookingWithRooms = {
    ...bookingInformation,
    rooms,
  }

  useEffect(() => {
    if (step) setCurrentIndex(stepsMap[step])
  }, [step])

  const steps = [
    <CheckAvailability
      existingBooking={bookingWithRooms}
      modifyDatesSectionRef={modifyDatesSectionRef}
      propertyId={propertyId}
      key={`${step}-${currentIndex}`}
      newDates={datesAndPaxes}
    />,
    <SelectOffer
      key={`SelectOffer-${step}-${currentIndex}`}
      {...datesAndPaxes}
      beds={bookingInformation.beds}
      sellingCurrent={sellingRate}
      existingBooking={bookingWithRooms}
    />,
    <ConfirmOffer
      key={`ConfirmOffer-${step}-${currentIndex}`}
      board={boardSelected}
      hash={bookingInformation?.hash}
      existingBooking={bookingWithRooms}
    />,
    <ConfirmationError
      key={`CANCEL_NOT_OK-${step}-${currentIndex}`}
      variant="CANCELLATION_NOT_OK"
    />,
    <ConfirmationError
      key={`RESERV_NOT_OK-${step}-${currentIndex}`}
      variant="RESERVATION_NOT_OK"
    />,
  ]

  return steps[currentIndex]
}

CheckAvailability.propTypes = {
  bookingInformation: PropTypes.arrayOf(typeBookingInformation),
  modifyDatesSectionRef: typeRef,
  propertyId: PropTypes.string.isRequired,
  sellingRate: PropTypes.number,
  rooms: PropTypes.number.isRequired,
}

ModifyDates.displayName = 'ModifyDates'

ModifyDates.ConfirmExit = ConfirmExit

export default ModifyDates
